export function isValidMessage(message: string) {
  return (
    message.trim() !== '' &&
    message.trim() !== '\n' &&
    message.trim() !== '\r' &&
    message.trim() !== '\t' &&
    message.trim() !== '\f' &&
    message.trim() !== '\v'
  );
}
